import setActiveRoom from './setActiveRoom';

export default {
	setActiveRoom,
};
